import { Component, h, Prop, State, Listen, Method } from '@stencil/core';
import { User, AUTHENTICATION_STATE } from '../aafp-authentication-wrapper/userService';

/**
 * COMPNAME is designed to render a shopping cart icon with DOM methods for updating the number of items in cart and authentication state.
 */
@Component({
  tag: 'aafp-shopping-cart',
  shadow: false,
})
export class AafpShoppingCart {
  /**
   * Link to shopping cart page
   */
  @Prop() cartUrl!: string;
  /**
   * Aria label
   */
  @Prop() cartLabel!: string;
  @State() isLoggedIn: boolean;
  @State() itemsCount: number = 0;
  userData: User | null;

  @Listen('userDataLoaded', { target: 'document' })
  onUserDataLoaded({ detail }: CustomEvent) {
    this.userData = detail;
    this.setAuthenticationState(this.userData);
  }

  shoppingCartWithItems() {
    return (
      <div class="adl-shopping-cart__icon--active">
        <i class="material-icons">add_shopping_cart</i>
      </div>
    );
  }

  emptyShoppingCart() {
    return <i class="material-icons">shopping_cart</i>;
  }

  @Method()
  async setAuthenticationState(userData: User | null): Promise<void> {
    this.isLoggedIn = userData && userData.IsLoggedIn === AUTHENTICATION_STATE.LOGGED_IN ? true : false;
  }

  @Method()
  async setItemsCountState(count: number): Promise<void> {
    this.itemsCount = count;
  }

  render() {
    const itemCount = this.itemsCount ? this.itemsCount.toString() : '0';
    const itemsInCart = this.itemsCount && this.itemsCount > 0 ? true : false;
    return (
      <div id="shopping-cart" class="adl-shopping-cart">
        <a
          class="adl-universal-nav__icon-link adl-universal-nav__link adl-shopping-cart__icon"
          href={this.cartUrl}
          aria-label={this.cartLabel}
          title={itemCount}
        >
          {itemsInCart && this.shoppingCartWithItems()}
          {!itemsInCart && this.emptyShoppingCart()}
        </a>
      </div>
    );
  }
}
